export var BiomarkerPanelType;
(function (BiomarkerPanelType) {
    BiomarkerPanelType["Panel"] = "Panel";
    BiomarkerPanelType["PanelOrder"] = "Panel Order";
})(BiomarkerPanelType || (BiomarkerPanelType = {}));
export var RecommendedSensitivity;
(function (RecommendedSensitivity) {
    RecommendedSensitivity["Benefit"] = "Benefit";
    RecommendedSensitivity["LackOfBenefit"] = "Lack of Benefit";
})(RecommendedSensitivity || (RecommendedSensitivity = {}));
